// extracted by css-extract-rspack-plugin
export default {"card":"Xi1CptjGozo2RR6E","cardSelected":"tVLcGuTCIzYYMW8S","cardButton":"ZtYy8rBr9u0jR17G","description":"C4TUp2RAqkd_FIih","cardFooter":"oCLy09O3hY3AEvZM"};